(function () {
  const path = window.location.pathname.replace(/\/$/, '');

  const pages = {
    '/pages/nosotros': {
      title: 'Nosotros',
      content: `
       <h2>Bienvenidos a Fajas Queen</h2>

        <p>En <strong>Fajas Queen</strong> nos especializamos en la comercialización de fajas moldeadoras, postquirúrgicas, deportivas y prendas de control de alta calidad. Nuestro compromiso es ofrecer productos que brinden comodidad, soporte y confianza en cada etapa del proceso de compra.</p>

        <p>Atendemos clientes en toda Colombia a través de nuestro sitio web oficial <strong>fajasqueen.com</strong>, ofreciendo asesoría personalizada antes, durante y después de cada compra.</p>

        <h2>Nuestra empresa</h2>

        <p><strong>Fajas Queen®</strong> es la marca comercial del establecimiento de comercio <strong>FAJAS QUEEN COL</strong>, cuyo titular es <strong>PARRA MARTIN KATY JINETH</strong>, identificada con NIT <strong>10101843651-1</strong> y registrada en la Cámara de Comercio de Bucaramanga.</p>

        <p>La marca <strong>Fajas Queen®</strong> es utilizada oficialmente en nuestro sitio web, redes sociales y demás canales de atención al cliente para identificar nuestros productos y servicios.</p>

        <p>Desde nuestro sitio web comercializamos fajas moldeadoras, postquirúrgicas, deportivas y prendas de control, realizando envíos a todo el territorio colombiano.</p>

        <h2>Información legal</h2>

        <p><strong>Marca comercial:</strong> Fajas Queen®</p>
        <p><strong>Establecimiento de comercio:</strong> FAJAS QUEEN COL</p>
        <p><strong>Titular:</strong> PARRA MARTIN KATY JINETH</p>
        <p><strong>NIT:</strong> 10101843651-1</p>
        <p><strong>Registro mercantil:</strong> Cámara de Comercio de Bucaramanga</p>
         `
    },
    '/policies/refund-policy': {
      title: 'Cambios y devoluciones',
      content: `
        <p>En Fajas Queen queremos que te sientas segura con tu compra. Si necesitas solicitar un cambio, revisaremos tu caso según las condiciones de la prenda y la política vigente.</p>
        <p>Por higiene y cuidado de nuestras clientas, las fajas, cinturillas y prendas íntimas deben conservarse sin uso, limpias, sin olores, con etiquetas y empaque original.</p>
        <p>No se aceptan cambios de prendas usadas, lavadas, modificadas o en mal estado. Si recibes un producto diferente al solicitado o con alguna novedad, escríbenos lo antes posible por nuestros canales de atención para ayudarte.</p>
      `
    },
    '/pages/cambios-y-devoluciones': {
      title: 'Cambios y devoluciones',
      content: `
        <p>En Fajas Queen queremos que te sientas segura con tu compra. Si necesitas solicitar un cambio, revisaremos tu caso según las condiciones de la prenda y la política vigente.</p>
        <p>Por higiene y cuidado de nuestras clientas, las fajas, cinturillas y prendas íntimas deben conservarse sin uso, limpias, sin olores, con etiquetas y empaque original.</p>
        <p>No se aceptan cambios de prendas usadas, lavadas, modificadas o en mal estado. Si recibes un producto diferente al solicitado o con alguna novedad, escríbenos lo antes posible por nuestros canales de atención para ayudarte.</p>
      `
    },
    '/policies/shipping-policy': {
      title: 'Política de envíos',
      content: `
        <p>Realizamos envíos a diferentes ciudades y municipios de Colombia, sujetos a cobertura de la transportadora.</p>
        <p>El valor del envío y el tiempo estimado de entrega podrán variar según tu ubicación. Durante el proceso de compra se mostrará la información disponible antes de finalizar el pedido.</p>
        <p>Una vez despachado el pedido, recibirás la información necesaria para hacer seguimiento. Fajas Queen no se hace responsable por demoras ocasionadas por datos incorrectos, ausencia del cliente en la entrega, novedades logísticas o situaciones externas a la tienda.</p>
      `
    },
    '/pages/politica-de-envios': {
      title: 'Política de envíos',
      content: `
        <p>Realizamos envíos a diferentes ciudades y municipios de Colombia, sujetos a cobertura de la transportadora.</p>
        <p>El valor del envío y el tiempo estimado de entrega podrán variar según tu ubicación. Durante el proceso de compra se mostrará la información disponible antes de finalizar el pedido.</p>
        <p>Una vez despachado el pedido, recibirás la información necesaria para hacer seguimiento. Fajas Queen no se hace responsable por demoras ocasionadas por datos incorrectos, ausencia del cliente en la entrega, novedades logísticas o situaciones externas a la tienda.</p>
      `
    },
    '/pages/cuidado-de-tu-queen': {
      title: 'Cuidado de tu Queen',
      content: `
        <h2>Cuida tu prenda para conservar su ajuste</h2>
        <p>Lava tu faja o cinturilla a mano con agua fria y jabon suave. Evita retorcerla para no afectar las fibras de compresion.</p>
        <p>No uses blanqueador, no planches y no seques directamente al sol. Dejala secar a la sombra sobre una superficie limpia.</p>
        <p>Te recomendamos alternar el uso si tienes mas de una prenda, guardarla completamente seca y revisar siempre las indicaciones especificas del producto.</p>
      `
    },
    '/policies/privacy-policy': {
      title: 'Privacidad y datos personales',
      content: `
        <p>En Fajas Queen cuidamos tu información personal. Los datos que nos compartes son utilizados únicamente para gestionar tus pedidos, responder tus solicitudes, brindarte asesoría, mejorar tu experiencia de compra y enviarte información relacionada con nuestros productos cuando lo autorices.</p>
        <p>No vendemos ni compartimos tu información personal con terceros no autorizados. Tus datos podrán ser tratados por plataformas de pago, transporte o herramientas necesarias para completar tu compra de forma segura.</p>
        <p>Al usar nuestra tienda aceptas el tratamiento de tus datos conforme a nuestra política de privacidad y a la normativa aplicable en Colombia.</p>
      `
    },
    '/pages/privacidad-datos-personales': {
      title: 'Privacidad y datos personales',
      content: `
        <p>En Fajas Queen cuidamos tu información personal. Los datos que nos compartes son utilizados únicamente para gestionar tus pedidos, responder tus solicitudes, brindarte asesoría, mejorar tu experiencia de compra y enviarte información relacionada con nuestros productos cuando lo autorices.</p>
        <p>No vendemos ni compartimos tu información personal con terceros no autorizados. Tus datos podrán ser tratados por plataformas de pago, transporte o herramientas necesarias para completar tu compra de forma segura.</p>
        <p>Al usar nuestra tienda aceptas el tratamiento de tus datos conforme a nuestra política de privacidad y a la normativa aplicable en Colombia.</p>
      `
    },
    '/policies/terms-of-service': {
      title: 'Términos y condiciones',
      content: `
        <p>Al comprar en Fajas Queen aceptas las condiciones comerciales de nuestra tienda.</p>
        <p>Nuestros productos están diseñados para brindar ajuste, soporte y comodidad, pero los resultados pueden variar según el cuerpo, uso y constancia de cada persona. Te recomendamos elegir tu talla según la guía disponible y no seleccionar una talla menor buscando mayor compresión.</p>
        <p>Los precios, promociones, disponibilidad de productos y tiempos de entrega pueden cambiar sin previo aviso. La compra se confirma una vez el pago sea aprobado o el pedido sea validado según el método de pago seleccionado.</p>
        <p>Para cualquier duda, puedes comunicarte con nuestro equipo de atención antes de realizar tu compra.</p>
      `
    },
    '/pages/terminos-y-condiciones': {
      title: 'Términos y condiciones',
      content: `
        <p>Al comprar en Fajas Queen aceptas las condiciones comerciales de nuestra tienda.</p>
        <p>Nuestros productos están diseñados para brindar ajuste, soporte y comodidad, pero los resultados pueden variar según el cuerpo, uso y constancia de cada persona. Te recomendamos elegir tu talla según la guía disponible y no seleccionar una talla menor buscando mayor compresión.</p>
        <p>Los precios, promociones, disponibilidad de productos y tiempos de entrega pueden cambiar sin previo aviso. La compra se confirma una vez el pago sea aprobado o el pedido sea validado según el método de pago seleccionado.</p>
        <p>Para cualquier duda, puedes comunicarte con nuestro equipo de atención antes de realizar tu compra.</p>
      `
    }
  };

  const currentPage = pages[path];

  if (!currentPage) {
    return;
  }

  const renderContent = () => {
    const main = document.getElementById('MainContent');

    if (!main) {
      return;
    }

    document.title = `${currentPage.title} | Fajas Queen`;
    main.innerHTML = `
      <div class="fq-policy">
        <div class="fq-policy__inner page-width page-width--narrow">
          <p class="fq-policy__eyebrow">Fajas Queen</p>
          <h1 class="fq-policy__title">${currentPage.title}</h1>
          <div class="fq-policy__content rte">${currentPage.content}</div>
          <a class="fq-policy__back" href="/">Volver a la tienda →</a>
        </div>
      </div>
    `;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderContent);
  } else {
    renderContent();
  }
})();
